import { useEffect, useState } from "react";
import { useActiveMotion } from "../hooks/useActiveMotion";

const roleRounds = [
  { role: "Frontend Engineer", portal: "Darwinbox", field: "Candidate name" },
  { role: "Product Engineer", portal: "Workday", field: "Full legal name" },
  { role: "Software Engineer", portal: "PeopleStrong", field: "Name as on ID" },
  { role: "UI Engineer", portal: "Custom ATS", field: "Applicant name" },
  { role: "Full-stack Engineer", portal: "Greenhouse", field: "Your full name" },
  { role: "Platform Engineer", portal: "Oracle Taleo", field: "Legal first and last name" },
  { role: "React Developer", portal: "SAP SuccessFactors", field: "Candidate full name" },
  { role: "Design Engineer", portal: "Lever", field: "Name" }
] as const;

export function RepeatPain() {
  const [round, setRound] = useState(0);
  const { ref, motionActive, prefersReducedMotion } = useActiveMotion<HTMLDivElement>();
  const active = roleRounds[round];

  useEffect(() => {
    if (!motionActive) return;
    const timer = window.setInterval(
      () => setRound((current) => (current + 1) % roleRounds.length),
      1900
    );
    return () => window.clearInterval(timer);
  }, [motionActive]);

  return (
    <div
      className={`repeat-stage ${prefersReducedMotion ? "is-reduced" : ""}`}
      ref={ref}
      aria-label="Illustration of repeated application forms"
    >
      <div className="repeat-card-stack" aria-hidden="true">
        <div className="repeat-sheet repeat-sheet--1" />
        <div className="repeat-sheet repeat-sheet--2" />
        <article className="repeat-sheet repeat-sheet--3" key={active.role}>
          <header className="repeat-sheet__head">
            <span>{active.portal}</span>
            <small>{active.role}</small>
          </header>
          <label className="repeat-sheet__field">
            <span>{active.field}</span>
            <b>Aarav Mehta</b>
          </label>
          <footer className="repeat-sheet__foot">
            <span>{String(round + 1).padStart(2, "0")} / {String(roleRounds.length).padStart(2, "0")}</span>
            <strong>Same answer · typed again</strong>
          </footer>
        </article>
        <div className="repeat-stamp" key={`stamp-${round}`}>again.</div>
      </div>
      <p className="repeat-stage__count">Same facts. Eight different ways of asking.</p>
    </div>
  );
}
